import Vue from "vue";
import Vuetify from "vuetify/lib";

// Langs
import ru from "vuetify/es5/locale/ru";
import en from "vuetify/es5/locale/en";

// Icons
import DragHandle from "@/components/Icons/DragHandle.vue";

Vue.use(Vuetify);

export const VuetifyConfig = {
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#2194F3",

        "primary-selected-main": "#C2E2FB",
        "primary-selected-secondary": "#E3F2FD",

        "table-hover": "#F6F6F6",

        accidental: "#5D3DFF",

        "background-main": "#FFFFFF",
        "background-secondary": "#F6F6F6",
        "background-tertiary": "#F6F6F6",

        disabled: "#E8E8E9",
        "disabled-input": "#F6F6F6",

        "border-main": "#EAEAEB",
        "border-secondary": "#A5A5A5",

        scrollbar: "#C3C3C3",
        "scrollbar-back": "#F6F6F6",

        "icon-main": "#A5A5A5",
        "icon-secondary": "#676767",
        "icon-tertiary": "#FFFFFF",
        "icon-light": "#F8F8F8",
        "icon-dark": "#333333",
        "icon-disabled": "#BDBEC0",

        "text-main": "#333333",
        "text-secondary": "#808080",
        "text-tertiary": "#FFFFFF",
        "text-light": "#F8F8F8",
        "text-dark": "#333333",
        "text-disabled": "#BDBEC0",

        sidebar: {
          lighten5: "#FAF9FF",
          lighten4: "#F4F3FC",
          lighten3: "#ECEBF4",
          lighten2: "#DEDDE5",
          lighten1: "#BAB9C2",
          base: "#9B9AA2",
          darken1: "#727179",
          darken2: "#5E5D65",
          darken3: "#3F3F46",
          darken4: "#242429"
        },

        "heat-map1": "#99CF68",
        "heat-map2": "#FFF48C",
        "heat-map3": "#F2675E",

        "graph-line01": "#F68B1F",
        "graph-line02": "#00B7C6",
        "graph-line03": "#F32162",
        "graph-line04": "#B53319",
        "graph-line05": "#CBF321",
        "graph-line06": "#F32162",
        "graph-line07": "#E721F3",
        "graph-line08": "#2DF321",
        "graph-line09": "#2196F3",
        "graph-line10": "#708DA4",
        "graph-line11": "#90CBF9",

        "chart-pie01": "#85E783",
        "chart-pie02": "#FFCF4D",
        "chart-pie03": "#FFA68F",
        "chart-pie04": "#90C4FF",
        "chart-pie05": "#CBA2FF",
        "chart-pie06": "#CECECE",

        "chart-bar01": "#CBA2FF",
        "chart-bar02": "#FFCF4D",
        "chart-bar03": "#FFA68F"
      },
      dark: {
        primary: "#4FAAF5",

        "primary-selected-main": "#567CBD",
        "primary-selected-secondary": "#588FD1",

        "table-hover": "#35353B",

        accidental: "#7F65FF",

        "background-main": "#242429",
        "background-secondary": "#161618",
        "background-tertiary": "#303036",

        disabled: "#3D3D42",
        "disabled-input": "#56565D",

        "border-main": "#37363A",
        "border-secondary": "#5F5F5F",

        scrollbar: "#5F5F5F",
        "scrollbar-back": "#37363A",

        "icon-main": "#A5A5A5",
        "icon-secondary": "#CCCCCC",
        "icon-tertiary": "#333333",
        "icon-light": "#F8F8F8",
        "icon-dark": "#333333",
        "icon-disabled": "#67676F",

        "text-main": "#F8F8F8",
        "text-secondary": "#999999",
        "text-tertiary": "#333333",
        "text-light": "#F8F8F8",
        "text-dark": "#333333",
        "text-disabled": "#67676F",

        sidebar: {
          lighten5: "#FAF9FF",
          lighten4: "#F4F3FC",
          lighten3: "#ECEBF4",
          lighten2: "#DEDDE5",
          lighten1: "#BAB9C2",
          base: "#9B9AA2",
          darken1: "#727179",
          darken2: "#5E5D65",
          darken3: "#3F3F46",
          darken4: "#242429"
        },

        "heat-map1": "#669F32",
        "heat-map2": "#F0D900",
        "heat-map3": "#EE3B2F",

        "graph-line01": "#F68B1F",
        "graph-line02": "#00B7C6",
        "graph-line03": "#F32162",
        "graph-line04": "#B53319",
        "graph-line05": "#CBF321",
        "graph-line06": "#F32162",
        "graph-line07": "#E721F3",
        "graph-line08": "#2DF321",
        "graph-line09": "#2196F3",
        "graph-line10": "#708DA4",
        "graph-line11": "#90CBF9",

        "chart-pie01": "#85E783",
        "chart-pie02": "#FFCF4D",
        "chart-pie03": "#FFA68F",
        "chart-pie04": "#90C4FF",
        "chart-pie05": "#CBA2FF",
        "chart-pie06": "#CECECE",

        "chart-bar01": "#CBA2FF",
        "chart-bar02": "#FFCF4D",
        "chart-bar03": "#FFA68F"
      }
    }
  },
  lang: {
    locales: { ru, en },
    current: "ru"
  },
  icons: {
    iconfont: "mdi", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    values: {
      // используем иконку например вот так: <v-icon>$vuetify.icons.reload</v-icon>
      DragHandle: { component: DragHandle }
    }
  }
};

export default new Vuetify(VuetifyConfig);
